import React from "react";
import { parse } from "query-string";

export type User = {
  userId: number;
  token: string;
  companyId: number;
};

const AuthContext = React.createContext<User | null | undefined>(undefined);

function AuthProvider(props: object) {
  let user: User | null = null;

  const temp = window.sessionStorage.getItem("AUTH");

  if (temp) {
    user = JSON.parse(temp);
  }

  if (!user) {
    const result = readUserFromParams();
    if (result) {
      user = result;
      window.sessionStorage.setItem("AUTH", JSON.stringify(user));
    }
  }

  return <AuthContext.Provider value={user} {...props} />;
}

function readUserFromParams(): User | undefined {
  let { userid, token, companyid } = parse(window.location.search);
  if (!userid || userid instanceof Array) {
    return undefined;
  }

  if (!token || token instanceof Array) {
    return undefined;
  }

  if (!companyid || companyid instanceof Array) {
    return undefined;
  }

  return {
    userId: parseInt(userid as string, 10),
    token: `Basic ${token}`,
    companyId: parseInt(companyid as string, 10)
  };
}

// Keeps the credentials of the launch URL in session storage and takes the token out of the
// address bar, so that it does not stay in the history or reach telemetry. Call it before Sentry.init.
function takeUserFromParams() {
  if (!window.sessionStorage.getItem("AUTH")) {
    const user = readUserFromParams();
    if (user) {
      window.sessionStorage.setItem("AUTH", JSON.stringify(user));
    }
  }

  const params = new URLSearchParams(window.location.search);
  if (params.has("token")) {
    params.delete("token");
    const search = params.toString();
    window.history.replaceState(
      window.history.state,
      "",
      `${window.location.pathname}${search ? `?${search}` : ""}${window.location.hash}`
    );
  }
}

function useAuth() {
  const context = React.useContext(AuthContext);

  if (context === undefined) {
    throw new Error("useAuth must be used within AuthProvider");
  }

  return context;
}

export { AuthProvider, takeUserFromParams, useAuth };
